import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../../../store/actions/profileActions';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import ProfileChipContainer from '../../../Profile/elements/ProfileChipContainer';

const Interests = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [open, setOpen] = useState(false);
    const profileState = useSelector(state => state.profile);
    const dispatch = useDispatch();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpen(false);
      };
    
    useEffect(() => {
        if (profileState.profile.interests !== profileState.userProfile.interests) {
            setIsEditing(true);
        } else {
            
            setIsEditing(false);
        }
    })

    const handleReset = () => {
        dispatch(actions.collectProfileData({...profileState.profile, interests: profileState.userProfile.intertests}));
        setIsEditing(false);
    }

    const handleSave = () => {
        dispatch(actions.updateProfile(profileState.profile))
            .then(() => {
                setOpen(true);
                setIsEditing(false);
            });
    }

    const availableInterests = [
        "baking","netflix","road-trips","spirituality","cooking","sports","writing",
        "coffee","drinking","reading","clubbing","food","museums",
        "crafts","art","board-games","gaming","podcasts","dancing","photography",
        "tech","ice-skating","karaoke","karate","knitting","lacrose","make-up",
        "movies","tattoos","running", "rugby","politics","pets","meditating",
        "painting","poetry","puzzles","quizzes","martial-arts","social-media","shopping",
        "soccer","sailing","sky-diving","surfing","swimming","thrifting","tennis",
        "travel","tourism","videography","vr","volunteering","wrestling","yoga",
        "zumba","zoo","youtube"
    ];

    return (
        <div>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    Profile Successfully Updated!
                </Alert>
            </Snackbar>
            <ProfileChipContainer interests={availableInterests} containerFit={{width: '100%'}} />
        </div>
    );
}

export default Interests;
